module.exports = __webpack_public_path__ + "assets/webgl/Assets_1_base_color.jpg.ace5cd54.webp";